import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownOutline } from '../../../../modules/infra/ui/dropdown';
import { Button } from '../../../../modules/infra/ui/button';
import { WaitingListLabel } from './WaitingListLabel';
import { WaitingListLinkOnly } from './WaitingListLinkOnly';
export var WaitingListsDropdown = function (_a) {
    var customersWaiting = _a.customersWaiting, date = _a.date, onOpenWalkInList = _a.onOpenWalkInList;
    return (_jsxs(DropdownOutline, { label: _jsx(WaitingListLabel, { customersWaiting: customersWaiting }), className: "u-ml-", children: [_jsx(DropdownOutline.Option, { children: _jsx(WaitingListLinkOnly, { date: date, customersWaiting: customersWaiting }) }), _jsx(DropdownOutline.Option, { children: _jsx(Button.Text, { fullWidth: true, onClick: onOpenWalkInList, children: "Walk-in List" }) })] }));
};
WaitingListsDropdown.defaultProps = {
    customersWaiting: 0,
    date: '',
};
